import { useState } from "react";
import { useNavigate } from "react-router-dom";
// import { Link } from "react-router-dom";
// import { useQuery } from "react-query";
import { AddModal, Confirmation, Reason } from "../../Components/Modal";
import Table from "../../Components/Table";
import StatusHandler from "../../Components/Table/StatusHandler";
import useTableControls from "../../Hooks/useTableControls";
import useFetchData from "../../Hooks/useFetchData";
import { getVehicleRequests } from "../../Services/VehicleRequest";
import { format_date, getSerialNumber } from "../../Utils/helpers";
import PageHeader from "../../Components/PageHeader";
import "../Dashboard/Dashboard.css";

export default function VehicleManagement() {
    const navigate = useNavigate();

    // const sampleData = [
    //   {
    //     sn: "1",
    //     moverFullName: "Mark Carson",
    //     vehicleName: "ABC Vehicle",
    //     vehicleType: "ABC Type",
    //     date: "01/02/2022",
    //     requestApprovalStatus: "pending",
    //   },
    //   {
    //     sn: "2",
    //     moverFullName: "Mark Carson",
    //     vehicleName: "ABC Vehicle",
    //     vehicleType: "ABC Type",
    //     date: "01/02/2022",
    //     requestApprovalStatus: "pending",
    //   },
    //   {
    //     sn: "3",
    //     moverFullName: "Mark Carson",
    //     vehicleName: "ABC Vehicle",
    //     vehicleType: "ABC Type",
    //     date: "01/02/2022",
    //     requestApprovalStatus: "accepted",
    //   },
    //   {
    //     sn: "4",
    //     moverFullName: "Mark Carson",
    //     vehicleName: "ABC Vehicle",
    //     vehicleType: "ABC Type",
    //     date: "01/02/2022",
    //     requestApprovalStatus: "accepted",
    //   },
    // ];

    const {
        perPage,
        setPerPage,
        status,
        setStatus,
        search_string,
        setSearchString,
        from,
        setFrom,
        to,
        setTo,
    } = useTableControls();

    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState("desc");

    const {
        // INTERNAL EXPORTS
        page,
        setPage,
        // REACT QUERY EXPORTS
        isFetching,
        isLoading,
        data,
        refetch,
    } = useFetchData("vehicleRequest_logs", getVehicleRequests, [
        perPage,
        search_string,
        "approved",
        from,
        to,
        sortField,
        sortOrder,
    ]);

    const onSortColumn = (field) => {
        setPage(1);
        if (field === sortField) {
            setSortOrder((o) => (o === "asc" ? "desc" : "asc"));
        } else {
            setSortField(field);
            setSortOrder("desc");
        }
    };
    // console.log("vehicleRequest_logs Data: ", data?.data);

    // Disabled: vehicle approve/reject — now handled via Driver Signup Requests
    // const { data: pendingRequestsData } = useQuery(
    //     ["vehicle_request_pending_count"],
    //     () => getVehicleRequests(1, 1, "", "pending", "", "", "createdAt", "desc"),
    //     { staleTime: 60 * 1000 }
    // );
    // const pendingVehicleRequestCount =
    //     pendingRequestsData?.data?.pagination?.total ?? 0;

    return (
        <div className="app-content content">
            <div className="content-wrapper">
                <div className="content-body">
                    {/* Basic form layout section start */}
                    <section id="configuration">
                        <div className="row">
                            <div className="col-12">
                                <div className="user-details-wrapper">
                                    <PageHeader
                                        title="Vehicle Management"
                                        subtitle="Manage fleet inventory, vehicle documentation, and assignment status"
                                        // Disabled: vehicle approve/reject — now handled via Driver Signup Requests
                                        // action={
                                        //     <Link
                                        //         to="/vehicle-management/vehicle-requests"
                                        //         className="siteBtn header-btn-standard w-100-mobile signup-requests-btn"
                                        //     >
                                        //         <i className="fas fa-file-alt me-2"></i>
                                        //         Requests
                                        //         {pendingVehicleRequestCount > 0 && (
                                        //             <span className="signup-requests-count-badge">
                                        //                 {pendingVehicleRequestCount}
                                        //             </span>
                                        //         )}
                                        //     </Link>
                                        // }
                                    />

                                    <Table
                                        key={"mover-management-signup-requests-table"}
                                        tableTitles={[
                                            "S.No.",
                                            "Driver Full Name",
                                            "Vehicle Name",
                                            "Vehicle Type",
                                            "Date Registered",
                                            "Action",
                                        ]}
                                        dateFilter
                                        showEntries
                                        isLoading={isLoading}
                                        isFetching={isFetching}
                                        data={data?.data?.data}
                                        totalPages={Math.max(
                                            1,
                                            Math.ceil(
                                                (data?.data?.pagination?.total || 0) /
                                                (data?.data?.pagination?.limit ||
                                                    Number(perPage) ||
                                                    10)
                                            )
                                        )}
                                        totalDocs={data?.data?.pagination?.total}
                                        page={page}

                                        setPage={setPage}
                                        setSearchString={setSearchString}
                                        status={status}
                                        setStatus={setStatus}
                                        perPage={perPage}
                                        setPerPage={setPerPage}
                                        from={from}
                                        setFrom={setFrom}
                                        to={to}
                                        setTo={setTo}
                                        sortColumnFields={[
                                            null,
                                            "user.firstName",
                                            "name",
                                            "type.name",
                                            "createdAt",
                                            null,
                                        ]}
                                        sortField={sortField}
                                        sortOrder={sortOrder}
                                        onSortColumn={onSortColumn}
                                    // status_options={[
                                    //   {
                                    //     label: "Pending",
                                    //     value: "pending",
                                    //   },
                                    //   {
                                    //     label: "Approved",
                                    //     value: "approved",
                                    //   },
                                    //   {
                                    //     label: "Rejected",
                                    //     value: "rejected",
                                    //   },
                                    // ]}
                                    >
                                        {data?.data?.data?.map((item, index) => (
                                                <tr>
                                                    <td>
                                                        {getSerialNumber(
                                                            {
                                                                page:
                                                                    data?.data?.pagination &&
                                                                        (data.data.pagination.limit ||
                                                                            Number(perPage))
                                                                        ? Math.floor(
                                                                            (data.data.pagination.skip || 0) /
                                                                            (data.data.pagination.limit ||
                                                                                Number(perPage) ||
                                                                                10)
                                                                        ) + 1
                                                                        : 1,
                                                                limit:
                                                                    data?.data?.pagination?.limit ||
                                                                    Number(perPage) ||
                                                                    10,
                                                            },
                                                            index
                                                        )}
                                                    </td>
                                                    <td>{item?.user?.firstName}</td>
                                                    <td>{item?.name}</td>
                                                    <td>{item?.type?.name ?? "—"}</td>
                                                    <td>
                                                        {item?.createdAt &&
                                                            format_date(item?.createdAt, "MM/DD/YYYY")}
                                                    </td>
                                                    <td>
                                                        <StatusHandler
                                                            key={`${item?._id}-status`}
                                                            view
                                                            // approval
                                                            item={item}
                                                            // isLoading={loadingStatus}
                                                            redirectUrl={`/vehicle-management/vehicle-details/${item?._id}`}
                                                        // onClick={() => {
                                                        //   if (item.requestApprovalStatus === "pending") {
                                                        //     Confirmation(
                                                        //       `Are You Sure You Want To Approve The Signup Request ?`,
                                                        //       "Yes",
                                                        //       () => console.log("Status Changed")
                                                        //     );
                                                        //   } else {
                                                        //     Reason(
                                                        //       "Are you sure you want to reject the signup request ?",
                                                        //       "Yes",
                                                        //       (val) => console.log("Val", val)
                                                        //     );
                                                        //   }
                                                        // }}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <style>{`
                .fw-800 { font-weight: 800; }
                
                @media (max-width: 576px) {
                    .w-100-mobile { width: 100% !important; text-align: center; justify-content: center; }
                    .user-details-wrapper { padding: 0.5rem; }
                }
            `}</style>
        </div>
    );
}
